/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination-theme')) {
	class Pagination extends HTMLElement {
		constructor() {
			super();

			const id = this.dataset.section;

			this.i = 2;
			this.button = this.querySelector('.load-more');
			this.grid = document.querySelector('[data-id='+id+']');
		}

		connectedCallback() {
			if ( this.classList.contains('pagination-type--loadmore') ) {
				this.loadMore();
			}
			if ( this.classList.contains('pagination-type--infinite') ) {
				this.infinite();
			}
		}

		loadMore() {
			let base = this;

			this.button.addEventListener('click', function() {
				if (base.dataset.type === 'tagalys') {
					window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
						direction: 'next'
					});

					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				} else {
					base.loadProducts();
				}

				this.blur();

				return false;
			});
		}

		infinite() {
			let base = this;

			base.observer = new IntersectionObserver(function(entries) {
				if (entries[0].isIntersecting) {
					if (base.dataset.type === 'tagalys') {
						const hasNextPage = window.theme.tagalys.results.SDK.helpers.hasNextPage()

						if (!hasNextPage) {
							if (base.observer) {
								base.observer.unobserve(base);
							}
						} else {
							window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
								direction: 'next'
							});
						}
					} else {
						base.loadProducts();
					}
				}
			}, {
				threshold: 0,
				rootMargin: '0px 0px 100px 0px'
			});

			base.observer.observe(base);
		}

		addUrlParam(search, key) {
			var newParam = key + '=' + this.i,
			params = '?' + newParam;

		  // If the "search" string exists, then build params from it
			if (search) {
				// Try to replace an existance instance
				params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

				// If nothing was replaced, then add the new param to the end
				if (params === search) {
					params += '&' + newParam;
				}
			}

			return params;
		}

		loadProducts() {
			let base = this,

			url = document.location.pathname + base.addUrlParam(document.location.search, 'page');

			if (base.getAttribute('loading') || base.i > parseInt(base.dataset.pages)) {
				return;
			}

			base.i++;

			base.setAttribute('loading', true);

			fetch(url)
				.then(response => response.text())
				.then((responseText) => {
					const html = responseText;

					if (this.i > 1) {
						const hiddenProducts = document.querySelectorAll('#product-grid .hidden-product');
						hiddenProducts.forEach(product => product.classList.remove('hidden-product'));
					}
				base.renderProducts(html, url);

				dispatchCustomEvent('pagination:page-changed', {
					url: url
				});
			});

      setTimeout(function(){ HulkappWishlist.init(); }, 2000);
		}

		renderProducts(html, url) {
			let base = this,
					grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

			if (!grid_to_replace) {
				if (base.observer) {
					base.observer.unobserve(base);
				}

				base.removeAttribute('loading');

				if ( base.button ) {
					base.button.classList.add('visually-hidden');
				}
				return;
			}

			let products = grid_to_replace.querySelectorAll('.column');

			for (var i = 0; i < products.length; i++) {
				this.grid.appendChild(products[i]);
			}
			gsap.set(products, {
				opacity: 0,
				y: 30
      });

			gsap.to(products, {
				duration: 0.5,
				y: 0,
				opacity: 1,
				stagger: 0.05,
				onComplete: function() {
					base.removeAttribute('loading');
				}
			});
		}
	}
	customElements.define('pagination-theme', Pagination);
}
